var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 574.8 214.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0000cb;}.cls-2{fill:#3c3c3b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.27,105.05c.73,43.98-20.28,61.57-71.83,60.34v-29.56c3.42,.24,4.64,.24,6.84,.24,9.53,0,17.59-2.2,22.48-6.11,6.84-5.62,9.04-13.19,9.04-32.98V27.36h-38.36V0h71.83V105.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.18,49.84V121.42c0,16.61-3.42,25.9-12.7,33.71-9.04,7.57-21.74,11.73-36.65,11.73-15.64,0-29.07-4.4-37.87-12.46-8.06-7.33-11.97-18.08-11.97-32.98V49.84h31.03V119.47c0,12.7,7.57,21.25,18.81,21.25s18.32-7.33,18.32-19.3V49.84h31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.61,17.83c0,9.53-7.33,16.86-17.1,16.86s-17.35-7.33-17.35-17.1S309.49,.25,319.51,.25s17.1,7.33,17.1,17.59Zm-1.71,145.12h-31.03V49.84h31.03v113.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.8,150.01c-12.95,11.73-26.38,16.86-43.49,16.86-34.45,0-59.86-25.41-59.86-59.86s24.92-61.08,60.1-61.08c16.86,0,30.78,5.86,45.2,18.81l-20.77,18.81c-6.84-6.84-14.17-10.02-23.21-10.02-17.1,0-29.81,13.93-29.81,32.49s12.95,33.23,31.03,33.23c8.06,0,13.92-2.44,21.99-9.53l18.81,20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.82,49.84h32.98l-63.76,164.66h-33.23l21.25-54.24-39.58-110.43h32.98l22.96,67.19,26.39-67.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.02,59.91C-.71,16.3,20.13-1.15,71.26,.06V29.38c-3.39-.24-4.6-.24-6.79-.24-9.45,0-17.45,2.18-22.29,6.06-6.79,5.57-8.97,13.08-8.97,32.71v69.06h38.04v27.14H.02V59.91Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso1);
export default __webpack_public_path__ + "static/media/Recurso 1.a8fc828e00c7a349a3ed0f3327f66a5c.svg";
export { ForwardRef as ReactComponent };